import BrowserDetect from './BrowserDetect';
import Responsive from './Responsive';
import Accordion from './Accordion';
import SpNavi from './SpNavi';
import link_icon from './link_icon';
/* ===============================================
Check responsive state
=============================================== */
// const r = new Responsive();

// $(window).on('resize',function(){
// check is responsive;
// 	console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());
/* ===============================================
SP Navi
=============================================== */
//通常盤
let param = {
	target:'#spnavi',
	trigger:'.btn_sp_navi',
	filter:'#resposive_flg',
	speed:200
};
const spnavi = new SpNavi(param);
spnavi.exec();

/**
 * 外部リンク・PDF・Word・Exlsに_blankの自動付与
 *
 */
link_icon();

//グローバルナビのアクション
$(function(){
	$(window).on('resize',function(){
		navi_action();
	});


	navi_action();

	function navi_action(){
		let ww = $(window).width();
		if(ww > 1024) {
			$('.gnavi li').mouseenter(function(event) {
				var sub = $($(this).find('.sub_navi'));
				if(sub.length > 0){
					$(sub).stop(true).show(200);
					$(sub).addClass('_on');
				}
			}).mouseleave(function(){
				var sub = $($(this).find('.sub_navi'));
				if(sub.length > 0){
					sub.stop(true).hide(50);
					sub.removeClass('_on');
				}
			});

			$('.gnavi').mouseenter(function(event) {
				$('#sub_navi_area').stop(true).animate({'height':34},300);
			}).stop(true,true).mouseleave(function(){
				$('#sub_navi_area').stop(true).animate({'height':10},300);
			});
		}
	}

});
